import { IEltCustomerRevenue } from 'legacy/lut/classes/models/partner360/ELT/docEltType/IEltCustomerRevenue'
import { TComplexSectionData } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { getFormedEltTranslation } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getFormedEltTranslation'
import { useTableActions } from 'legacy/lut/components/widgets/public/partner360/ELT/hooks/useTableActions'
import { StyledTable } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/styledTable/StyledTable'
import { Title } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/title/Title'
import { useMemo } from 'react'

import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { RoundTableLabel } from '../../roundTable/components/roundTableLabel/RoundTableLabel'
import { RoundTableSection } from '../../roundTable/components/roundTableSection/RoundTableSection'

import { calculateCustomerRevenueTotalAndYoY } from './helpers/calculateCustomerRevenueTotalAndYoY'
import { getCustomerRevenueColumns } from './helpers/getCustomerRevenueColumns'

import styles from './CustomerRevenue.module.scss'

interface ICustomerRevenueProps {
  data: IEltCustomerRevenue[]
  netNdpValue: ActualsValueTypes
  updateFormData: (data: TComplexSectionData) => void
  fYear: number
  fQuarter: number
}

const KEY_FIELD = 'TranslationKey'
export const CustomerRevenue = ({
  data,
  updateFormData,
  fYear,
  netNdpValue,
  fQuarter,
}: ICustomerRevenueProps) => {
  const { onChangeByKey } = useTableActions<IEltCustomerRevenue>({
    updateFormData: updateFormData,
    data: data,
    changeComputedFieldsFn: calculateCustomerRevenueTotalAndYoY,
  })

  const columns = useMemo(
    () =>
      getCustomerRevenueColumns({
        netNdpValue,
        onChange: onChangeByKey(KEY_FIELD),
        currentYear: fYear,
        currentQuarter: fQuarter,
      }),
    [onChangeByKey, fYear, fQuarter, netNdpValue]
  )

  return (
    <RoundTableSection>
      <Title
        rightContent={<RoundTableLabel />}
        variant="withBackground"
        text={getFormedEltTranslation('doc-section-customer-revenue')}
        translationReplaceParams={[
          {
            key: '{netNdp}',
            value: netNdpValue.toUpperCase(),
          },
        ]}
      />

      <StyledTable<IEltCustomerRevenue>
        columns={columns}
        items={data}
        keyField={KEY_FIELD}
        classes={{ td: styles.shortTdWidth }}
      />
    </RoundTableSection>
  )
}
